import Gallery from '@modules/gallery/Gallery.ts'
;(function () {
    const articleProfile = document.querySelector('.article-profile')

    if (!articleProfile) return

    const articleElements = document.querySelectorAll('.article-list__element')

    articleElements.forEach((articleElement) => {
        const galleryEl = articleElement.querySelector('.article-list__element__images')
        if (galleryEl) {
            new Gallery({
                element: galleryEl,
                loop: false,
                key: 'overflow-gallery',
                controls: true,
            })
        }
    })
})()
